import React, { createContext, useContext, ReactNode } from 'react';

export interface TimelineHeadersContextState {
  registerScroll: (e: HTMLDivElement) => void;
  rightSidebarWidth: number;
  leftSidebarWidth: number;
  timeSteps: Record<string, unknown>;
}

const defaultContextState: TimelineHeadersContextState = {
  registerScroll: () => {
    console.warn('default registerScroll header used');
  },
  rightSidebarWidth: 0,
  leftSidebarWidth: 150,
  timeSteps: {},
};

const HeaderContext = createContext<typeof defaultContextState>(defaultContextState);

export interface TimelineHeadersProviderProps {
  children: ReactNode;
  rightSidebarWidth?: number;
  leftSidebarWidth: number;
  timeSteps: object;
  registerScroll: (e: HTMLDivElement) => void;
}

export function TimelineHeadersProvider({
  children,
  rightSidebarWidth = 0,
  leftSidebarWidth,
  timeSteps,
  registerScroll,
}: TimelineHeadersProviderProps) {
  const contextValue = {
    rightSidebarWidth,
    leftSidebarWidth,
    timeSteps: timeSteps as typeof defaultContextState.timeSteps,
    registerScroll,
  };
  return <HeaderContext.Provider value={contextValue}>{children}</HeaderContext.Provider>;
}

TimelineHeadersProvider.displayName = 'TimelineHeadersProvider';

export const TimelineHeadersContext = HeaderContext;
export const useTimelineHeadersContext = () => useContext(TimelineHeadersContext);
